import React from "react";
import { getDayColor } from "../getDayColor";
import { getDayScore } from "../utils/habitUtils";
import { Habit, Day } from "../types";

interface DayButtonProps {
  day: string;
  habits: Habit[];
  days: Day[];
  selectedDay: string;
  onClick: (day: string) => void;
}

export const DayButton: React.FC<DayButtonProps> = ({
  day,
  habits,
  days,
  selectedDay,
  onClick,
}) => {
  const isFutureDay = new Date(day) > new Date();
  const habitCountForDay = days.find((d) => d.date === day)?.habits.length || 0;
  const dayScore = getDayScore(day, days);

  return (
    <div
      onClick={() => onClick(day)}
      data-testid={`day-button-${new Date(day).getDate()}`}
      style={{
        backgroundColor: getDayColor(habits, dayScore, habitCountForDay),
        border: day === selectedDay ? "1px solid rgba(128,128,128,0.5)" : "none",
        borderRadius: "50%",
        width: `calc(100% / 8)`,
        aspectRatio: "1/1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0",
        cursor: isFutureDay ? "not-allowed" : "pointer",
        color: isFutureDay ? "#ccc" : "#000",
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
      }}
    >
      <span>{new Date(day).getDate()}</span>
    </div>
  );
};